<template>
  <aha-modal
    :title="titleAutoRenewal"
    ref="auto-renew-confirm-popup"
    id="auto-renew-confirm-popup"
    @hide="handleModalConfirmOk()"
    action-position="justify-center"
  >
    <p class="mb-3">
      {{ $i18nPresenter.t('Thank you for using AhaSlides!') }}
    </p>
    <template #action>
      <aha-button class="w-16 mb-2" @click="handleModalConfirmOk()">
        {{ $i18nPresenter.t('OK') }}
      </aha-button>
    </template>
  </aha-modal>
</template>
<script >
export default {
  name: 'AutoRenewModal',
  props: {
    titleAutoRenewal: {
      type: String,
      default: '',
    },
  },
  methods: {
    handleModalConfirmOk() {
      this.$emit('handleModalConfirmOk')
    },
  },

}
</script>
